import Vue from 'vue'
import ApiRequest from '@/services/ApiRequests/ApiRequest'
import PaymentApi from '@/services/Api/PaymentApi'

import { ROLES } from '@/store/admin'

const parsePaymentCounters = (payload) => {
  return payload.reduce((counters, data) => {
    return { ...counters, [data.operation]: data.count }
  }, {})
}

const paymentCountersApiRequest = new ApiRequest(PaymentApi.fetchCounters)
const postponedSwiftCounterApiRequest = new ApiRequest(PaymentApi.fetchPostponedSwiftCounter)

const state = () => ({
  counters: {
    PAYMENT_STATUS_ON_HOLD: 0,
    PAYMENT_STATUS_ON_HOLD_INTEGRATOR: 0,
    MANUAL: 0,
    PENDING: 0,
    VERIFICATION: 0,
    IDENTIFIED_RECIPIENT_VERIFICATION: 0,
    PROCESSING: 0,
    PAYMENT_STATUS_PENDING_CANCELLATION: 0,
    FAILED: 0,
    POSTPONED_SWIFT: 0
  }
})

const getters = {
  onHoldPaymentTotalCount: (state) => {
    return state.counters.PAYMENT_STATUS_ON_HOLD
  },
  onHoldIntegratorPaymentTotalCount: (state) => {
    return state.counters.PAYMENT_STATUS_ON_HOLD_INTEGRATOR
  },
  unassignedPaymentTotalCount: (state) => {
    return state.counters.MANUAL
  },
  pendingPaymentTotalCount: (state) => {
    return state.counters.PENDING
  },
  verificationPaymentTotalCount: (state) => {
    return state.counters.VERIFICATION
  },
  identifiedRecipientVerificationPaymentTotalCount: (state) => {
    return state.counters.IDENTIFIED_RECIPIENT_VERIFICATION
  },
  processingPaymentTotalCount: (state) => {
    return state.counters.PROCESSING
  },
  pendingCancelationPaymentTotalCount: (state) => {
    return state.counters.PAYMENT_STATUS_PENDING_CANCELLATION
  },
  errorPaymentTotalCount: (state) => {
    return state.counters.FAILED
  },
  postponedSwiftPaymentTotalCount: (state) => {
    return state.counters.POSTPONED_SWIFT
  }
}

const actions = {
  loadPaymentCounters ({ commit, rootGetters }) {
    const hasAccountantSwiftAuthority = rootGetters['admin/hasRole'](ROLES.ACCOUNTANT_SWIFT)

    return Promise.all([
      paymentCountersApiRequest.execute(),
      hasAccountantSwiftAuthority ? postponedSwiftCounterApiRequest.execute() : undefined
    ])
      .then(([paymentCounters, postponedSwiftCounter]) => {
        commit('setCounters', {
          ...parsePaymentCounters(paymentCounters),
          ...{ 'POSTPONED_SWIFT': postponedSwiftCounter?.count || 0 }
        })
      })
      .catch(() => {})
  },
  cancelLoadPaymentCounters () {
    paymentCountersApiRequest.cancel()
    postponedSwiftCounterApiRequest.cancel()
  }
}

const mutations = {
  setCounters (state, counters) {
    Vue.set(state, 'counters', counters)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
